﻿/* global analytics_data */
import { analyticsEvent } from '../../controllers/analytics-controller';

var FreeContentToggleController = function ($location, searchService, searchBootstrapper,$timeout) {
  "use strict";

  this.searchService = searchService;
  this.searchBootstrapper = searchBootstrapper;
  this.location = $location;
  
  this.update = function () {
      analyticsEvent($.extend(analytics_data, {
        event_name: 'entitlement_toggle'
    }));
      //Create showFreecontent Filter if not exist
      var filter = this.searchService.getFilter('entitledcontentonly');
      if (!filter) {
          this.searchBootstrapper.createFilter('entitledcontentonly', '1');
      } else {
          if (filter._value === '1') {
              filter.setValue('');
          } else {
              filter.setValue('1');
              //Analytics event tracking
              analyticsEvent($.extend(analytics_data, {
                  event_name: 'entitlement_toggle',
                  search_utility: 'show_free_content'
              }));
          }
      }

      this.searchService._isNewSearch = true;
      this.searchService.getFilter('page').setValue("1");

      var routerBuilder = this.searchService.getRouteBuilder();
      var searchResults = this.searchService.getResults();
      if (searchResults) {
        if (searchResults.length > 0) {
            this.location.search(routerBuilder.getRoute());
        }
        else {
          if (angular.element(document.body).hasClass('theme-omdia')) {
            this.location.search("q=" + this.searchService.getFilter('q') + "&page=1&sortBy=relevance&sortOrder=desc");
          } else {
            this.location.search("q=" + this.searchService.getFilter('q') + "&page=1&sortBy=date&sortOrder=desc");
          }
        }
      } else {
        this.location.search(routerBuilder.getRoute());
      }
      this.searchService.query();
  };

  this.init = function () {
      var filter = this.searchService.getFilter('entitledcontentonly');
      return filter !== undefined;
  }

};
var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("FreeContentToggleController", ['$location', 'searchService', 'searchBootstrapper', '$timeout', FreeContentToggleController]);
